// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"356":"68d7d92f","564":"4f6f4920","622":"a93ec376","787":"d16d0675","975":"731ba299"}[chunkId] + ".chunk.js";
};